import { useEffect,useState } from 'react';
import styles from './TotalAcc.module.css'
import LineChart from './LineChart';
import { COLORS } from './constant';
import TestsetList from './TestsetList';
import ToggleSwitch from '../../compoenets/ToggleSwitch';


export default function TotalAcc({
    dashboardData,
    testsetList,
    toggle,
    setToggle,
}){

    return(
        <div className={styles['wrap']}>
            <header>
                <TestsetList
                data={testsetList}
                />
                <ToggleSwitch
                leftText='Precision'
                rightText='Threshold'
                checked={toggle!=='precision'}
                onChange={()=>setToggle(toggle==='precision'?'threshold':'precision')}
                />
            </header>
            <div className={styles['body']}>
                <div className={styles['chart']}>
                    <LineChart 
                    data={dashboardData}
                    toggle={toggle}
                    />
                </div>
            </div>
        </div>
    )
}